import { SimpleTableTWProps } from './SimpleTableTW';
import React from 'react';
import { TableCard } from './TableCard';
import { SimpleTableBody } from './Bodies';
import { SortableTableHeader } from './Headers';

// This has the same appearance of the regular table, but accessor columns can be sorted
export function SimpleSortTable<T>({ table, ...rest }: SimpleTableTWProps<T>) {
  return (
    <TableCard>
      <SortableTableHeader table={table} {...rest} />
      <SimpleTableBody table={table} />
    </TableCard>
  );
}
